




interface ImageSlider extends HTMLElement {
    duration: number,
    slides: NodeListOf<HTMLElement>,
    currentSlide: number,
    loop: boolean,
    navigation: boolean,
    navigationItems: NodeListOf<HTMLElement>,
}





class ImageSlider extends HTMLElement {

    constructor () {
        super();


        this.duration = 4000;
        this.loop = true;
        this.navigation = true;

        if ( this.attributes["loop"] && this.attributes["loop"].nodeValue === 'false' ) {
            this.loop = false;
        }

        if ( this.attributes["navigation"] && this.attributes["navigation"].nodeValue === 'false' ) {
            this.loop = false;
        }

        this.classList.add('activated');

        this.slides = this.querySelectorAll('.slide');

        if ( this.slides.length === 0 ) {
            this.navigation = false;
        }

        const style = document.createElement("style");
        style.textContent = `
        image-slider .slide {
            translate: -100vw 0;
            transition: translate .5s ease-in-out;
        }

        image-slider .slide.active {
            translate: 0 0;
        }

        image-slider .slide.active ~ .slide {
            translate: 100vw 0;
        }

        image-slider .nav-item::before {
            animation-duration: ${this.duration}ms;
        }
        `;
        this.append(style);

        if ( this.navigation && this.slides.length > 1 ) {
            this.setupNavigation();
        }

        this.setSlideActive(0);
    }

    setSlideActive (index : number) {
        if ( this.slides[index] ) {
            this.slides
                .forEach(slide => slide.classList.remove('active'));

            this.slides[index].classList.add('active');
            this.currentSlide = index;
        }

        if ( this.navigationItems ) {
            this.navigationItems.forEach(item => item.classList.remove('active'));
            if ( this.navigationItems[index] ) {
                this.navigationItems[index].classList.add('active');
            }
        }
        
        if ( index < this.slides.length ) {
            window.setTimeout(() => this.setSlideActive(this.currentSlide + 1), this.duration);
        } else if ( this.loop && index === this.slides.length ) {
            this.setSlideActive(0);
        }
    }

    setupNavigation () {
        const navigationHolder = document.createElement('nav');
        navigationHolder.classList.add('navigation');

        this.slides.forEach(_ => {
            const slideElem = document.createElement('span');
            slideElem.classList.add('nav-item');
            navigationHolder.append(slideElem);
        });

        this.append(navigationHolder);

        this.navigationItems = navigationHolder.querySelectorAll('.nav-item');

    }

}



export function setupImageSlider () {
    customElements.define('image-slider', ImageSlider);
}
